



/*
FrFr FRIENDLY FRAMEWORK
frfr-pagination-utils.js
Version ID: 1a 2025-04-04r1
by 
// Please describe here if you customized this file
*/


/*
DOKUMENTACIJA:
- 

*/


export const pagination_utils = {};


//
pagination_utils.pages_count_get = (size, perPage) => {
  let _size = 0;
  if (size > 0) {
    _size = size;
  }
  let pages_count;
  if (perPage > 0) {
    pages_count = Math.ceil(_size / perPage);
  } else {
    pages_count = 1;
  }
  if (pages_count > 0) {
  } else {
    pages_count = 1;
  }
  return pages_count;
};

pagination_utils.prev_page_no_get = (size, perPage, page_no) => {
  let prev_page_no = -1;
  if (page_no > 1) {
    prev_page_no = page_no - 1;
  }
  return prev_page_no;
};


//
pagination_utils.next_page_no_get = (size, perPage, page_no) => {
  let next_page_no = page_no + 1;
  const pages_count = pagination_utils.pages_count_get(size, perPage);
  if (next_page_no > pages_count) {
    next_page_no = -1; // there is no next page
  }
  return next_page_no;
};


//
pagination_utils.is_item_in_page = (perPage, page_no, item_index) => {
  if (perPage > 0) {
    const page_index = page_no - 1;
    let min_index = 0;
    if (page_index > 0) {
      min_index = page_index * perPage;
    }
    const max_index = min_index - 1 + perPage;
    if (item_index > min_index || item_index === min_index) {
      if (item_index < max_index || item_index === max_index) {
        return true;
      }
    }
    // else
    return false;
  } else { // CASE no pagination
    return true;
  }
};

